module.exports = __webpack_public_path__ + "static/media/sw1.153fdb59.jpg";